import React from 'react';
import { Grommet, ThemeType } from 'grommet';
import { GROMMETTHEME } from '../constants/grommetTheme';
import { useLocation } from 'react-router-dom';
import SHDThemeOverride from '@ui/ThemeOverride/SHDThemeOverride';

interface Props {}

const GrommetContainer: React.FC<React.PropsWithChildren<Props>> = ({
  children,
  ...props
}) => {
  const newThemePaths = [
    '/get-started-sports',
    '/get-started-vb',
    '/get-started',
    '/invite',
    '/onboarding',
    '/phone_signin',
    '/signin',
    '/signup',
  ];
  const location = useLocation();
  const isThemePathMatch = newThemePaths.some((path) =>
    location.pathname.includes(path)
  );

  return (
    <>
      {isThemePathMatch ? (
        <SHDThemeOverride>{children}</SHDThemeOverride>
      ) : (
        <Grommet
          full="min"
          theme={GROMMETTHEME as unknown as ThemeType}
          {...props}
        >
          {children}
        </Grommet>
      )}
    </>
  );
};

export default GrommetContainer;
